<nz-spin [nzTip]="loadingText" [nzSpinning]="isLoading">
  <nz-card>
    <div class="main-card">
      <h3 nz-typography class="nfl-form-label">{{ activeCard?.title }}</h3>
      <form *ngIf="form && activeCard" nz-form [nzLayout]="'vertical'" [formGroup]="form" class="form-grid">
        <ng-container *ngFor="let field of activeCard.formDetails">
          <ng-container [ngSwitch]="field.fieldType">
            <ng-container *ngSwitchCase="'text'">
              <nz-form-item
                [ngClass]="{
                  'full-width': field?.layout === 'full',
                  'half-width': field?.layout === 'half',
                }"
              >
                <nz-form-label class="nfl-form-label" [nzFor]="field.fieldName">{{ field.label }}</nz-form-label>
                <nz-form-control [nzErrorTip]="field.errorText">
                  <input
                    nz-input
                    [formControlName]="field.fieldName"
                    [id]="field.fieldName"
                    appTrimFormInput
                    [placeholder]="field.placeholder"
                  />
                </nz-form-control>
              </nz-form-item>
            </ng-container>
            <ng-container *ngSwitchCase="'password'">
              <nz-form-item
                [ngClass]="{
                  'full-width': field?.layout === 'full',
                  'half-width': field?.layout === 'half',
                }"
              >
                <nz-form-label class="nfl-form-label" [nzFor]="field.fieldName">{{ field.label }}</nz-form-label>
                <nz-form-control [nzErrorTip]="field.errorText">
                  <input
                    nz-input
                    [formControlName]="field.fieldName"
                    [id]="field.fieldName"
                    appTrimFormInput
                    [placeholder]="field.placeholder"
                    [type]="field.fieldType"
                  />
                </nz-form-control>
              </nz-form-item>
            </ng-container>
            <ng-container *ngSwitchCase="'textarea'">
              <nz-form-item
                [ngClass]="{
                  'full-width': field?.layout === 'full',
                  'half-width': field?.layout === 'half',
                }"
              >
                <nz-form-label class="nfl-form-label" [nzFor]="field.fieldName">{{ field.label }}</nz-form-label>
                <nz-form-control [nzErrorTip]="field.errorText">
                  <textarea
                    nz-input
                    [formControlName]="field.fieldName"
                    [id]="field.fieldName"
                    [placeholder]="field.placeholder"
                    [nzAutosize]="{ minRows: 6, maxRows: 12 }"
                  ></textarea>
                </nz-form-control>
              </nz-form-item>
            </ng-container>
            <ng-container *ngSwitchCase="'fileUpload'">
              <nz-form-item
                [ngClass]="{
                  'full-width': field?.layout === 'full',
                  'half-width': field?.layout === 'half',
                }"
              >
                <app-file-upload
                  title="Upload File to S3 bucket"
                  parent="data-connection"
                  (uploadCompleted)="onUploadCompleted($event)"
                ></app-file-upload>
              </nz-form-item>
            </ng-container>
          </ng-container>
        </ng-container>
      </form>

      <!-- Grant Access Section for AWS S3 -->
      <ng-container *ngIf="activeCard?.key === ConnectionType.AWS_S3">
        <div class="grant-access-section">
          <h4 nz-typography class="nfl-form-label">Grant Access ( AWS Policies )</h4>

          <nz-tabset class="policy-tabs">
            <nz-tab *ngFor="let policy of policyTabs" [nzTitle]="policy.title">
              <div class="policy-content">
                <div class="policy-header">
                  <h5 nz-typography class="nfl-form-label">{{ policy.headerTitle }}</h5>
                  <div class="policy-actions">
                    <button
                      nz-button
                      nzType="default"
                      nzSize="small"
                      (click)="copyPolicyToClipboard(policy.type)"
                      nz-tooltip
                      nzTooltipTitle="Copy to clipboard"
                    >
                      <span nz-icon nzType="copy" nzTheme="outline"></span>
                      Copy
                    </button>
                    <button
                      nz-button
                      nzType="primary"
                      nzSize="small"
                      (click)="downloadPolicyFile(policy.type)"
                      nz-tooltip
                      nzTooltipTitle="Download policy file"
                    >
                      <span nz-icon nzType="download" nzTheme="outline"></span>
                      Download.json
                    </button>
                  </div>
                </div>
                <div class="policy-preview">
                  <pre class="policy-json">{{ policyContents[policy.key] }}</pre>
                </div>
              </div>
            </nz-tab>
          </nz-tabset>
        </div>
      </ng-container>
      <form
        *ngIf="form && activeCard && activeCard?.key === ConnectionType.AWS_S3"
        nz-form
        [nzLayout]="'vertical'"
        class="checkbox-form"
        [formGroup]="form"
      >
        <h4 nz-typography class="nfl-form-label">Setup Checklist</h4>
        <ng-container *ngFor="let field of activeCard.formDetails">
          <ng-container *ngIf="field.fieldType === 'checkbox'">
            <nz-form-item>
              <label nz-checkbox [formControlName]="field.fieldName">{{ field.label }}</label>
            </nz-form-item>
          </ng-container>
        </ng-container>
      </form>
    </div>

    <div class="action-buttons">
      <div>
        <button nz-button nzType="default" (click)="goBack()">Back</button>
      </div>
      <div class="right-btn-section">
        <button
          nz-button
          nzType="default"
          [disabled]="form?.invalid || isLoading || activeConnectionStatus === ConnectionStatus.SUCCESS"
          (click)="testDataConnection()"
          [nzLoading]="isLoading"
          *ngIf="!activeCard?.hideTest"
        >
          Test Connection
        </button>
        <button
          *ngIf="!isEdit"
          nz-button
          nzType="primary"
          [disabled]="disableConnectButton()"
          (click)="activeCard!.key === ConnectionType.SFTP ? initiateUpload() : createDataConnection()"
        >
          Connect
        </button>
        <button
          *ngIf="isEdit"
          nz-button
          nzType="primary"
          [disabled]="disableConnectButton()"
          (click)="activeCard!.key === ConnectionType.SFTP ? initiateUpload() : updateDataConnection()"
        >
          Update
        </button>
      </div>
    </div>
  </nz-card>
</nz-spin>
